import React from 'react';
import {ScrollView, Text, View} from 'react-native';
import {IThemeType} from '../../theme/IThemeType';
import WelcomeBody from './body';
import WelcomeFooter from './footer';
import WelcomeHeader from './Header';
import {BaseViewProps, BaseViewState, WelcomeBaseView} from './WelcomeBaseView';
import Color from '../../theme/Color';

interface WelcomeProps extends BaseViewProps {}
interface WelcomeState extends BaseViewState {}

export default class Welcome extends WelcomeBaseView<
  WelcomeProps,
  WelcomeState
> {
  render() {
    return (
      <View
        style={{
          backgroundColor:
            this.props.activetheme?.v3?.welcome_screen?.bottom_background
              ?.color || Color.white,
          flex: 1,
        }}>
        <WelcomeHeader {...this.props} />
        <ScrollView style={{flex: 1, backgroundColor: Color.transparent}}>
          <WelcomeBody {...this.props} />
        </ScrollView>
        <WelcomeFooter {...this.props} />
      </View>
    );
  }
}
